// input mask is clipping last number, if phone number is given without leading plus
export const fixPhoneNumber = (phone: string) => `+${phone}`;

// +7-921-999-88-77
const PHONE_REGEX = /(\d)(\d{3})(\d{3})(\d{2})(\d{2})/;
const PARTS_DELIMETER = '-';

export const formatPhone = (phone: string) => {
    const [,region, ...groups] = phone.match(PHONE_REGEX) ?? [];

    if (!region) {
        throw new Error('Incorrect phone format')
    }

    const prefixedRegion = `+${region}`;
    const phoneParts = [
        prefixedRegion,
        ...groups
    ]
    
    return phoneParts.join(PARTS_DELIMETER);
}
